import React, { ChangeEvent, useState } from 'react';
import { TextInput } from '@mantine/core';
import { TextInputProps } from '@mantine/core';

function CurrencyInput({
  value,
  defaultValue,
  onChange,
  ...props
}: TextInputProps) {
  const [internalValue, setInternalValue] = useState(defaultValue || '');

  const formatWithCommas = (
    num: string | null | readonly string[] | number,
  ) => {
    if (num === '' || num === null || isNaN(Number(num))) return '';

    const [integerPart, fractionalPart] = num.toString().split('.'); // Split into integer and fractional parts
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas to the integer part

    return fractionalPart !== undefined
      ? `${formattedInteger}.${capToTwoDigits(fractionalPart)}`
      : formattedInteger;
  };

  const capToTwoDigits = (num: string) => {
    if (num.length > 2) {
      return num.slice(0, 2);
    }
    return num;
  };

  const cleanValue = (formattedValue: string) => {
    return formattedValue.replace(/,/g, '');
  };

  const handleChange = (event: ChangeEvent<{ value: string }>) => {
    const rawValue = event.target.value; // The raw input value (including commas)
    const numericValue = cleanValue(rawValue); // Remove commas to get the numeric value

    const formattedValue = formatWithCommas(numericValue);

    setInternalValue(formattedValue);

    if (onChange) {
      // @ts-expect-error it just works
      onChange(numericValue);
    }
  };

  return (
    <TextInput
      value={value !== undefined ? formatWithCommas(value) : internalValue}
      onChange={handleChange}
      {...props}
    />
  );
}

export default CurrencyInput;
